supportsResultCaching